module.exports = __webpack_public_path__ + "static/media/delu_jackson.7f739324.png";